export const filterQuestions = (form, questions = [], lang) => {
  return questions.filter((item) => {
    if (form.experience) {
      switch (form.experience) {
        case 'IT&nIT': {
          if (item.key === 'experienceIt') {
            return true;
          }
          if (item.key === 'experiencePreviousIt') {
            return false;
          }
          if (item.key === 'experienceNonIt') {
            return true;
          }
          if (item.key === 'experienceNone') {
            return false;
          }
          break;
        }
        case 'otherIT': {
          if (item.key === 'experienceIt') {
            return false;
          }
          if (item.key === 'experiencePreviousIt') {
            return true;
          }
          if (item.key === 'experienceNonIt') {
            return true;
          }
          if (item.key === 'experienceNone') {
            return false;
          }
          break;
        }
        case 'none': {
          if (item.key === 'experienceIt') {
            return false;
          }
          if (item.key === 'experiencePreviousIt') {
            return false;
          }
          if (item.key === 'experienceNone') {
            return true;
          }
          if (item.key === 'experienceNonIt' && lang === 'ru') {
            return true;
          }
          if (item.key === 'experienceNonIt' && lang === 'eng') {
            return false;
          }
          break;
        }
      }
    }
    return true;
  });
};
